import { useState, useCallback } from 'react';
import { Step } from '../../../shared/types';

interface UseStepNavigationResult {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  handleNext: () => void;
  handlePrevious: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  viewMode: 'horizontal' | 'vertical';
  setViewMode: (mode: 'horizontal' | 'vertical') => void;
}

export function useStepNavigation(steps?: Step[]): UseStepNavigationResult {
  const [currentStep, setCurrentStep] = useState(0);
  const [viewMode, setViewMode] = useState<'horizontal' | 'vertical'>('horizontal');

  const handleNext = useCallback(() => {
    if (steps && currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    }
  }, [currentStep, steps]);

  const handlePrevious = useCallback(() => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  }, [currentStep]);

  const isFirstStep = currentStep === 0;
  const isLastStep = steps ? currentStep === steps.length - 1 : false;

  return {
    currentStep,
    setCurrentStep,
    handleNext,
    handlePrevious,
    isFirstStep,
    isLastStep,
    viewMode,
    setViewMode,
  };
}

